import { loc1Tll, loc2Jhv } from "@/mock-api/data/locationsExample.ts";
import type { UsageBasedRevenue } from "@warrenio/api-spec/spec.oats.gen";

export const adminMonthlySubtotalsExample: UsageBasedRevenue[] = [
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 2814.63766185,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 807.5263,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 30131.829805,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 9021.5594,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 16771.944512505,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 3906.5950000000003,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 20073.8407023,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 580.183506,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 1057.658,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 2069.883522,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 4380.4593,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 1019.9314999999999,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 25.249000000000002,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 255.0709,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 461.7676,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 358.979264,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 63257.67,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 5.898816,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-01-01T00:00:00Z",
        subtotal: 98.595,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 9367.610865235,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 2635.9389,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 27777.0858575,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 8295.4382,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 18841.1323968,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 1484.1295,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 215.493516,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 970.4029999999999,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 1888.205256,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 3992.6263999999996,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 61.152,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 6688.223325,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 389.158,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 243.328512,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 58035.67,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 655.5696,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 44.470944,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-02-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 31354.3944175,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 9296.0399,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 13837.499176725001,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 3534.1803,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 22300.3023579,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 1030.26,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 7.114968,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 1106.3794,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 2238.6294,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 4393.4303,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 67.70400000000001,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 775.5132,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 269.399424,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 63075.67,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 3296.699105,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 56.919744,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-03-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 30454.2962675,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 9207.299500000001,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 12880.997131485,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 3379.8134999999997,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 18257.291696700002,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 1014.405,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 6.88275,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 1187.8615,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 2296.9696239,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 4271.8081,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 65.52,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 716.7622,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 260.70912,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 61393.57,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 3173.4612,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 57.108869999999996,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-04-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 31938.020065000004,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 9741.4114,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 13256.906716759999,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 3449.1478,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 18264.6340947,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 968.5305000000001,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 7.114968,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 1611.4539,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 2370.9974904,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 4578.152599999999,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 76.1425,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 269.399424,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 62982.57,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 681.2064,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 2703.558095,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 67.094244,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-05-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 12802.275899385,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 3331.384,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 33264.121695,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 9832.49925,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 18230.6416887,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 897.12,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 6.885144,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 1450.4105,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 2288.7975852,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 4570.9804,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 88.2,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 260.70912,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 61302.57,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 101.251836,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 660.3001999999999,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 2490.1128,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-06-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 35260.1678625,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 11684.6884,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 13183.699183235,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 3394.5443,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 16582.799898,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 927.0239999999999,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 7.1125739999999995,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 1599.9249,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 2409.0260607,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 4757.6865,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 91.14,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 269.399424,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 62860.07,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 138.981276,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 684.8688,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 2573.11656,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-07-01T00:00:00Z",
        subtotal: 259.14000000000004,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 36726.9357875,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 12052.8814,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 13269.650552235,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 3419.3768,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 17616.7099647,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 927.0239999999999,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 7.114968,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 1598.1084,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 2627.1638694,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 4746.9282,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 91.14,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 269.399424,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 62860.07,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 152.247627,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 711.5738,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 2573.11656,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-08-01T00:00:00Z",
        subtotal: 21.245,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 35024.4464675,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 11897.5605,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 4785.8412,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 1572.6165,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 12576.866312605,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 3325.6825,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 305.382,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 17198.456499,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 897.12,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 6.885144,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 2629.5999432,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 260.70912,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 61180.07,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 138.89149999999998,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 714.168,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 977.75692,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-09-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 12757.370420375,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 3416.189,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 12389.7284,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 36868.8163375,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 4994.4454,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 838.796,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 18257.3304795,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 927.0239999999999,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 7.1125739999999995,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 1693.76,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 2749.5494137,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 269.399424,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 62860.07,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 143.357508,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 737.9736,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 177.072,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-10-01T00:00:00Z",
        subtotal: 0.035,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 35739.64135,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 12120.3915,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 4776.7615,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 12235.338233825,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 3307.843,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 816.48,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 18661.9704642,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 897.12,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 6.885144,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 1615.222,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 2697.5311902,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 260.70912,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 61726.07,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 148.402214,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 714.168,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 171.36,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-11-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 558.60714,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 187.57585,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 73.7058,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 50.6275,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 12.474,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 291.7608498,
        type: "cloud_services",
        product_type: "OBJECT_STORAGE",
        location_slug: "",
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 13.706,
        type: "cloud_services",
        product_type: "BLOCK_STORAGE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 0.105336,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 27.91635,
        type: "cloud_services",
        product_type: "REPLICA_SNAPSHOT",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 41.2838118,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 185.3273955,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 3.983056,
        type: "cloud_services",
        product_type: "MANAGED_SERVICE_kubernetes",
        location_slug: loc1Tll,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 770.0,
        type: "cloud_services",
        product_type: "CUSTOM_PRODUCT",
        location_slug: "",
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 2.317392,
        type: "cloud_services",
        product_type: "REPLICA_BACKUP",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 10.9109,
        type: "cloud_services",
        product_type: "LICENSE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 2.618,
        type: "cloud_services",
        product_type: "VM_COMPUTE",
        location_slug: loc2Jhv,
    },
    {
        period_start_month: "2025-12-01T00:00:00Z",
        subtotal: 0.0,
        type: "credited_without_vat",
    },
];
